import getUserCompanies from '../data/monolith/companies';
import getCompanyContact from '../data/monolith/company-contact';

const getContactFormPersona = async () => {
  const getPrimaryUserCompany = async () => {
    const userCompanies = await getUserCompanies();
    const primaryUserCompany = {
      id: null,
      name: null,
    };
    if (userCompanies !== null) {
      for (let i = 0; i < userCompanies.length; i++) {
        if (
          userCompanies[i].pcn_business_experience === true ||
          userCompanies[i].my_company === true
        ) {
          primaryUserCompany.id = userCompanies[i].id;
          primaryUserCompany.name = userCompanies[i].name;
          break;
        }
        if (i === userCompanies.length - 1) {
          primaryUserCompany.id = userCompanies[i].id;
        }
      }
    }
    return primaryUserCompany;
  };

  const getPrimaryUserContact = async (companyId: number) => {
    const contact = {
      loginInformationId: null,
      firstName: null,
      lastName: null,
      email: null,
      mobilePhone: null,
    };
    const companyContact = await getCompanyContact(companyId);
    if (companyContact) {
      contact.loginInformationId = companyContact.id;
      contact.firstName = companyContact.first_name;
      contact.lastName = companyContact.last_name;
      contact.email = companyContact.email_address;
      contact.mobilePhone = companyContact.mobile_phone;
    }
    return contact;
  };

  const primaryUserCompany = await getPrimaryUserCompany();
  let primaryUserContact;
  if (primaryUserCompany.id) {
    primaryUserContact = await getPrimaryUserContact(primaryUserCompany.id);
  }
  return {
    companyId: primaryUserCompany.id,
    companyName: primaryUserCompany.name,
    loginInformationId: primaryUserContact
      ? primaryUserContact.loginInformationId
      : null,
    userFirstName: primaryUserContact ? primaryUserContact.firstName : null,
    userLastName: primaryUserContact ? primaryUserContact.lastName : null,
    userEmail: primaryUserContact ? primaryUserContact.email : null,
    userMobilePhone: primaryUserContact ? primaryUserContact.mobilePhone : null,
  };
};

export default getContactFormPersona;
